<template>
  <div
    :class="{ 'selected': isSelected, 'marked': isMarked }"
    @mousedown="$emit('click', option)"
    @mousemove="$emit('hover', option)"
    v-html="htmlHighlightedLabel"
  />
</template>

<script>
  import RbEventsMixin from 'vRoot/_mixins/RbEventsMixin.vue'

  export default {
    name: 'RbSelectOption',
    mixins: [RbEventsMixin],
    props: ['option', 'selected', 'marked', 'highlight', 'scroll', 'labelKey'],
    computed: {
      htmlHighlightedLabel () {
        return this.highlight && this.highlight.length
          ? this.option[this.labelKey].replace(new RegExp(`(${this.highlight})`, 'gi'), '<strong>$1</strong>')
          : this.option[this.labelKey]
      },
      isMarked(){
        const marked = this.marked && this.marked.id === this.option.id
        if(marked) this.scrollIntoView();
        return marked;
      },
      isSelected(){
        return this.selected && this.selected.id === this.option.id
      }
    },
    mounted () { if(this.isSelected) this.scrollIntoView(true) },
    methods: {
      scrollIntoView (scrollSelectedIntoView) {
        if (this.$el && this.scroll) {
          const thisElement = this.$el,
            scrollElementRect = this.$el.parentNode.getBoundingClientRect(),
            thisElementRect = thisElement.getBoundingClientRect()

          if(scrollSelectedIntoView) {
            const previous = thisElement.previousSibling
            if (previous && previous.nodeType === Node.ELEMENT_NODE) {
              previous.scrollIntoView(true)
            } else {
              thisElement.scrollIntoView(true)
            }
          } else if (scrollSelectedIntoView || thisElementRect.top < scrollElementRect.top) {
            thisElement.scrollIntoView(true)
          } else if (thisElementRect.bottom > scrollElementRect.bottom) {
            thisElement.scrollIntoView(false)
          }
        }
      }
    }
  }
</script>

<style lang="stylus"></style>
